// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Marked from "marked";
import * as ErrorPage from "./ErrorPage.bs.js";

function getOrErrorPage(res) {
  if (res.TAG === /* Ok */0) {
    return res._0;
  } else {
    return React.createElement(ErrorPage.make, {
                error: res._0
              });
  }
}

function parseMd(mdString) {
  return React.createElement("div", {
              dangerouslySetInnerHTML: {
                __html: Marked.marked(mdString)
              }
            });
}

export {
  getOrErrorPage ,
  parseMd ,
}
/* react Not a pure module */
